export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";